import React, { useState } from 'react';
import axios from 'axios';
import { Button, Form, FormGroup, Input } from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ExcelUploadComponent = () => {
  const [file, setFile] = useState(null);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append('file', file);

    try {
      await axios.post('http://localhost:8080/api/upload-excel', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      toast.success('File uploaded successfully', { autoClose: 1000 });

    } catch (error) {

      toast.error('Error uploading file', { autoClose: 1000 });
    }
  };

  return (
    <>
      <ToastContainer position="bottom-center" />
      <Form onSubmit={handleSubmit} >
        <FormGroup style={{ width: "50%" }}>
          <Input type="file" onChange={handleFileChange} />
        </FormGroup>
        <Button type="submit">Upload File</Button>
      </Form>
    </>
  );
};

export default ExcelUploadComponent;
